import { Phone, Envelope, MapPin, InstagramLogo, WhatsappLogo } from "@phosphor-icons/react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-white">
      <div className="container-main py-16 sm:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="font-['Playfair_Display'] text-2xl font-bold">DVT</span>
              <span className="font-['Outfit'] text-sm font-medium tracking-[0.15em] uppercase text-[#C46235]">
                Rezidans
              </span>
            </div>
            <p className="font-['Outfit'] text-sm text-white/60 leading-relaxed max-w-xs">
              Mardin'de apart otel konforunu 5 yıldızlı standartlarda sunan prestijli konaklama tesisi.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-['Outfit'] text-sm font-semibold uppercase tracking-wider text-white/40 mb-5">
              Hızlı Bağlantılar
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Hakkımızda", href: "#hakkimizda" },
                { label: "Olanaklar", href: "#olanaklar" },
                { label: "Konaklama", href: "#konaklama" },
                { label: "Galeri", href: "#galeri" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.href.slice(1)}`}
                    className="font-['Outfit'] text-sm text-white/60 hover:text-[#C46235] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Outfit'] text-sm font-semibold uppercase tracking-wider text-white/40 mb-5">
              İletişim
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#C46235]" />
                <a href="tel:+904825022483" className="font-['Outfit'] text-sm text-white/60 hover:text-[#C46235] transition-colors">0482 502 24 83</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#C46235]" />
                <a href="tel:+904825026111" className="font-['Outfit'] text-sm text-white/60 hover:text-[#C46235] transition-colors">0482 502 61 11</a>
              </li>
              <li className="flex items-center gap-3">
                <Envelope size={16} className="text-[#C46235]" />
                <a href="mailto:rezervasyon@dvtrezidans.com" className="font-['Outfit'] text-sm text-white/60 hover:text-[#C46235] transition-colors">rezervasyon@dvtrezidans.com</a>
              </li>
              <li className="flex items-center gap-3">
                <Envelope size={16} className="text-[#C46235]" />
                <a href="mailto:satis@dvtrezidans.com" className="font-['Outfit'] text-sm text-white/60 hover:text-[#C46235] transition-colors">satis@dvtrezidans.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#C46235] flex-shrink-0 mt-0.5" />
                <span className="font-['Outfit'] text-sm text-white/60">
                  Vefa Evleri Karşısı, Mardin
                </span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-['Outfit'] text-sm font-semibold uppercase tracking-wider text-white/40 mb-5">
              Sosyal Medya
            </h4>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/rezidansapart_dvt/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-instagram"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center transition-all duration-300 hover:bg-[#C46235] hover:scale-110"
              >
                <InstagramLogo size={20} weight="fill" />
              </a>
              <a
                href="https://wa.me/905302068721?text=Merhaba%2C%20DVT%20Rezidans%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-whatsapp"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center transition-all duration-300 hover:bg-[#25D366] hover:scale-110"
              >
                <WhatsappLogo size={20} weight="fill" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-['Outfit'] text-xs text-white/40">
            &copy; {year} DVT Rezidans. Tüm hakları saklıdır.
          </p>
          <p className="font-['Outfit'] text-xs text-white/30">
            Mardin'in Prestijli Konaklama Adresi
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
